// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run yarn gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../../../../../../../../schema/public';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DepositQueryVariables = Types.Exact<{
  currency?: Types.InputMaybe<Types.Scalars['String']['input']>;
  provider?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type DepositQuery = { __typename?: 'Query', banking?: { __typename?: 'Banking', id: string, myCurrentAddress?: { __typename?: 'BankingAddress', id: string, address?: string, accountAddress?: string, destinationTag?: string, createTime?: number } } };

export type DepositAddressFragment = { __typename?: 'BankingAddress', id: string, address?: string, accountAddress?: string, destinationTag?: string, createTime?: number };

export const DepositAddressFragmentDoc = /*#__PURE__*/ gql`
    fragment DepositAddress on BankingAddress {
  id
  address
  accountAddress
  destinationTag
  createTime
}
    `;
export const DepositQueryDocument = /*#__PURE__*/ gql`
    query DepositQuery($currency: String, $provider: String) {
  banking {
    id
    myCurrentAddress(currency: $currency, provider: $provider) {
      ...DepositAddress
    }
  }
}
    ${DepositAddressFragmentDoc}`;
export function useDepositQuery(baseOptions?: Apollo.QueryHookOptions<DepositQuery, DepositQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DepositQuery, DepositQueryVariables>(DepositQueryDocument, options);
      }
export function useDepositQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DepositQuery, DepositQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DepositQuery, DepositQueryVariables>(DepositQueryDocument, options);
        }
export function useDepositQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DepositQuery, DepositQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DepositQuery, DepositQueryVariables>(DepositQueryDocument, options);
        }
export type DepositQueryHookResult = ReturnType<typeof useDepositQuery>;
export type DepositQueryLazyQueryHookResult = ReturnType<typeof useDepositQueryLazyQuery>;
export type DepositQuerySuspenseQueryHookResult = ReturnType<typeof useDepositQuerySuspenseQuery>;
export type DepositQueryQueryResult = Apollo.QueryResult<DepositQuery, DepositQueryVariables>;